export default "__VITE_ASSET__BKB783aW__"